<template>
  <VDialogV3
    id="characteristic-unit-card"
    position="right"
    width="600px"
    height="100vh"
    :entity="localCharacteristicUnit"
    :context-menu="editMode ? CharacteristicUnitsService.contextMenu : null"
    :on-context-menu-action="onContextMenuAction"
    @submit="onSubmit"
  >
    <section>
      <VInput
        v-model="localCharacteristicUnit.name"
        label="Название"
        layout="vertical"
        required
        :validate-method="validateName"
      />
    </section>
  </VDialogV3>
</template>

<script lang="ts">

import CharacteristicUnit         from '@/domains/CharacteristicUnits/CharacteristicUnit';
import CharacteristicUnitsService from '@/domains/CharacteristicUnits/CharacteristicUnitsService';

export default defineComponent({
  name: 'CharacteristicUnitCard',

  props: {
    /** Готовый объект — передаётся из реестра */
    entity: {
      type:    CharacteristicUnit,
      default: null,
    },
    /** ID — карточка сама загружает объект */
    id: {
      type:    Number,
      default: null,
    },
  },

  data() {
    return {
      CharacteristicUnitsService,

      localCharacteristicUnit: null as CharacteristicUnit | null,
    };
  },

  computed: {
    editMode(): boolean {
      return this.localCharacteristicUnit?.isExisting ?? false;
    },
  },

  async mounted() {
    await this.init();
  },

  methods: {
    async init(): Promise<void> {
      if (this.id) {
        this.localCharacteristicUnit = await CharacteristicUnitsService.get(this.id);
      }
      else if (this.entity instanceof CharacteristicUnit) {
        this.localCharacteristicUnit = this.$core.utils.cloneDeep(this.entity);
      }
      else {
        this.localCharacteristicUnit = new CharacteristicUnit();
      }
    },

    async onSubmit(): Promise<void> {
      if (this.editMode) {
        const success = await CharacteristicUnitsService.update(this.localCharacteristicUnit);

        if (success) {
          this.$core.dialogs.CharacteristicUnitCard.resolve();
        }
      }
      else {
        const success = await CharacteristicUnitsService.add(this.localCharacteristicUnit);

        if (success) {
          this.$core.dialogs.CharacteristicUnitCard.resolve();
        }
      }
    },

    /**
     * Колбэк после действия пункта контекстного меню (refreshAfter !== false).
     * В карточке это «Удалить» — после удаления резолвим диалог: карточка
     * закроется, showCard вернёт true, реестр обновится (позиция исчезнет).
     * Перечитывания черновика здесь нет — карточка закрывается, затирать нечего.
     */
    onContextMenuAction(): void {
      this.$core.dialogs.CharacteristicUnitCard.resolve();
    },

    async validateName(value: string): string | null {
      if (typeof value !== 'string' || value.length === 0) return null;
      if (value.trim().length === 0) return 'Поле обязательно для заполнения и не может быть пустым';
      if (value.length > 50) return 'Максимальная длина поля 50 символов';
      return null;
    },
  },
});
</script>
